import {
  type ScenarioRunResponse,
  ScenarioRunStage
} from 'types/api/scenarios/runs/scenario-runs'

export const ACTIVE_RUN_STAGES = [
  ScenarioRunStage.SETUP,
  ScenarioRunStage.ACTIVE,
  ScenarioRunStage.HALTING
]

export const ERROR_RUN_STAGES = [
  ScenarioRunStage.SETUP_FAILED,
  ScenarioRunStage.FAILED
]

export const COMPLETED_RUN_STAGES = [
  ScenarioRunStage.HALTED,
  ScenarioRunStage.COMPLETED
]

export const TERMINAL_RUN_STAGES = [
  ...ERROR_RUN_STAGES,
  ...COMPLETED_RUN_STAGES
]

export const getRunStage = (run?: ScenarioRunResponse) => run?.stage_info?.stage

export const isRunInActiveStage = (run?: ScenarioRunResponse) => {
  const runStage = getRunStage(run)

  return Boolean(runStage && ACTIVE_RUN_STAGES.includes(runStage))
}

export const isRunInCompletedStage = (run: ScenarioRunResponse) => {
  const runStage = getRunStage(run)

  return (
    isRunInTerminalStage(run) ||
    Boolean(runStage && COMPLETED_RUN_STAGES.includes(runStage))
  )
}

export const isRunInErrorStage = (run: ScenarioRunResponse) => {
  const runStage = getRunStage(run)

  return Boolean(runStage && ERROR_RUN_STAGES.includes(runStage))
}

export const isRunInTerminalStage = (run: ScenarioRunResponse) => {
  const runStage = getRunStage(run)

  return Boolean(runStage && TERMINAL_RUN_STAGES.includes(runStage))
}

export const isRunHalting = (run: ScenarioRunResponse) =>
  getRunStage(run) === 'Halted'
